import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initMediaProtection, teardownMediaProtection } from '../lib/mediaProtection';

/**
 * Route-aware wrapper that enables website-wide image/video protection on
 * every distributor-facing page and turns it OFF on admin routes so
 * admins can right-click / drag / inspect media freely while managing
 * content (product images, category faces, ad videos, Cloudinary picker).
 *
 * Admin route prefixes:
 *   • /admin              — employee admin login + orders
 *   • /secure-admin-*     — super admin login + dashboard
 *
 * Everything else (Home, Cart, Checkout, Account, Orders, Info pages,
 * Login, Register, Pending Approval) is protected.
 *
 * Rendered as a null component — no DOM footprint.
 */
export default function MediaProtection() {
    const { pathname } = useLocation();

    const isAdminRoute =
        pathname === '/admin' ||
        pathname.startsWith('/admin/') ||
        pathname.startsWith('/secure-admin');

    useEffect(() => {
        if (isAdminRoute) {
            teardownMediaProtection();
        } else {
            initMediaProtection();
        }
        // No cleanup on unmount — App-level component lives for the whole
        // app lifetime; route changes re-run this effect and flip the
        // protection state cleanly.
    }, [isAdminRoute]);

    return null;
}
